import { Colour, Pill, PillSize, Tile } from '@ukpostbox/frontend-framework';
import React from 'react';
import { AccountStatEntryType } from '../../Types/UserAccountTypes';

function AccountStatEntry(props: AccountStatEntryType) {
	const newValue = props.value || 0;

	return (
		<Tile
			title={props.label}
			description={newValue.toString()}
			media={props.icon}
			badge={newValue > 0 && <Pill content={props.badgeLabel} colour={Colour.Warning} size={PillSize.Small} />}
			colour={newValue === 0 ? Colour.Secondary : Colour.Primary}
			onClick={() => props.callback()}
			disabled={newValue === 0}
		/>
	);
}

export { AccountStatEntry };
